import React from "react";
import { JSX } from "react/jsx-runtime";

const DeleteIcon = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) => {
  return (
    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M6.66406 8.19922V14.5992" stroke="#FF453A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M11.5195 8.19922V14.5992" stroke="#FF453A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M1 4.19922H17.185" stroke="#FF453A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M2.61914 4.19922H9.09316H15.5672V15.5135C15.5672 17.2177 14.118 18.5992 12.3302 18.5992H5.85615C4.0684 18.5992 2.61914 17.2177 2.61914 15.5135V4.19922Z" stroke="#FF453A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M5.85559 2.6C5.85559 1.71634 6.82176 1 8.0136 1H10.1716C11.3635 1 12.3296 1.71634 12.3296 2.6V4.2H5.85559V2.6Z" stroke="#FF453A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  );
};

export default DeleteIcon;
